<div class="mat-dialog">
  <h2 mat-dialog-title>{{ title }}</h2>
  <mat-dialog-content>
    {{ message }}
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button class="confirm-btn" (click)="onConfirm()">Yes</button>
    <button mat-button class="confirm-btn-no" (click)="onDismiss()">No</button>
  </mat-dialog-actions>
</div>